import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "navbar" }

import FooterComponent from "@/components/FooterComponent.vue"

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "nav-link"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("home", -1)
        ])),
        _: 1,
        __: [0]
      }),
      _cache[2] || (_cache[2] = _createElementVNode("a", {
        href: "https://www.freelancermap.de/profil/ariel-podzorski",
        class: "nav-link"
      }, "portfolio", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("a", {
        href: "https://medium.com/@arielpod",
        class: "nav-link"
      }, "blog", -1)),
      _createVNode(_component_router_link, {
        to: "/contact",
        class: "nav-link"
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode("contact", -1)
        ])),
        _: 1,
        __: [1]
      })
    ]),
    _createVNode(_component_router_view),
    _createVNode(FooterComponent)
  ]))
}
}

})